module.exports = __webpack_public_path__ + "static/media/register.dc56fe05.png";